import { render, staticRenderFns } from "./StemdoersManagerPage.vue?vue&type=template&id=3c060e29"
import script from "./StemdoersManagerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StemdoersManagerPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports